<div class="space-y-4">
  <!-- Alta -->
  <div class="p-3 rounded-lg border border-gray-200 dark:border-gray-700 grid grid-cols-1 md:grid-cols-2 gap-2">
    <input type="text" [(ngModel)]="newName" placeholder="Nombre del campo (ej: company_size)"
      class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
    <input type="text" [(ngModel)]="newLabel" placeholder="Etiqueta visible"
      class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">

    <select [(ngModel)]="newType"
      class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
      @for (t of fieldTypes; track t) { <option [ngValue]="t">{{ fieldTypeLabel(t) }}</option> }
    </select>
    <input type="text" [(ngModel)]="newPlaceholder" placeholder="Placeholder (opcional)"
      class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">

    @if (needsOptions(newType)) {
      <input type="text" [(ngModel)]="newOptions" placeholder='Opciones JSON: ["A","B","C"]'
        class="md:col-span-2 px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white font-mono">
    }

    <input type="text" [(ngModel)]="newCrmProperty" placeholder="CRM property (opcional)"
      class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">

    <!-- INC 38: lógica condicional del nuevo campo -->
    @if (availableConditionFields.length > 0) {
      <div class="md:col-span-2 rounded-lg border border-dashed border-gray-300 dark:border-gray-600 p-2.5 space-y-2">
        <label class="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
          <input type="checkbox" [(ngModel)]="newConditionalEnabled" class="h-4 w-4 rounded border-gray-300 text-brand-500">
          Mostrar este campo solo si se cumple una condición
        </label>
        @if (newConditionalEnabled) {
          <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
            <select [(ngModel)]="newConditionalField"
              class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
              <option value="">— Campo —</option>
              @for (cf of availableConditionFields; track cf.id) {
                <option [value]="cf.fieldName">{{ cf.fieldLabel }}</option>
              }
            </select>
            <select [(ngModel)]="newConditionalOperator"
              class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
              @for (op of conditionalOperators; track op.value) {
                <option [ngValue]="op.value">{{ op.label }}</option>
              }
            </select>
            <input type="text" [(ngModel)]="newConditionalValue" placeholder="Valor"
              class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
          </div>
        }
      </div>
    }

    <div class="flex items-center gap-3 md:col-span-2">
      <label class="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
        <input type="checkbox" [(ngModel)]="newRequired" class="h-4 w-4 rounded border-gray-300 text-brand-500">
        Obligatorio
      </label>
      <button type="button" (click)="add()" [disabled]="saving || !newName.trim() || !newLabel.trim()"
        class="ml-auto px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
        + Agregar
      </button>
    </div>
  </div>

  @if (loading) {
    <p class="text-sm text-gray-500 dark:text-gray-400">Cargando...</p>
  } @else if (items.length === 0) {
    <p class="text-sm text-gray-500 dark:text-gray-400">No hay campos configurados.</p>
  } @else {
    <ul class="divide-y divide-gray-200 dark:divide-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg">
      @for (item of items; track item.id) {
        <li class="py-2 px-3 flex items-start justify-between gap-3">
          <div class="min-w-0 flex-1">
            <div class="flex items-center gap-2 flex-wrap">
              <span class="font-medium text-gray-900 dark:text-white text-sm">{{ item.fieldLabel }}</span>
              <code class="text-xs text-gray-500 dark:text-gray-400">{{ item.fieldName }}</code>
              <span class="text-xs px-2 py-0.5 rounded bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300">{{ fieldTypeLabel(item.fieldType) }}</span>
              @if (item.isRequired) { <span class="text-xs px-2 py-0.5 rounded bg-error-50 text-error-600">req</span> }
              @if (item.isSystem) { <span class="text-xs px-2 py-0.5 rounded bg-brand-100 text-brand-700 dark:bg-brand-900/30 dark:text-brand-400">sistema</span> }
              @if (!item.isActive) { <span class="text-xs px-2 py-0.5 rounded bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300">inactivo</span> }
            </div>
            @if (item.placeholder) { <p class="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Placeholder: {{ item.placeholder }}</p> }
            @if (item.crmProperty) { <p class="text-xs text-gray-500 dark:text-gray-400">CRM: {{ item.crmProperty }}</p> }
            <!-- INC 38: resumen de la condición de visibilidad -->
            @if (conditionalSummary(item)) {
              <p class="text-xs text-brand-600 dark:text-brand-400 mt-0.5">⚡ {{ conditionalSummary(item) }}</p>
            }

            <!-- INC 38: editor inline de la condición -->
            @if (editingConditionalId === item.id) {
              <div class="mt-2 rounded-lg border border-dashed border-gray-300 dark:border-gray-600 p-2.5 space-y-2">
                <label class="flex items-center gap-2 text-sm font-medium text-gray-700 dark:text-gray-300">
                  <input type="checkbox" [(ngModel)]="editConditionalEnabled" class="h-4 w-4 rounded border-gray-300 text-brand-500">
                  Mostrar solo si se cumple una condición
                </label>
                @if (editConditionalEnabled) {
                  @if (conditionFieldsFor(item).length === 0) {
                    <p class="text-xs text-gray-500 dark:text-gray-400">No hay otros campos para usar como condición.</p>
                  } @else {
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">
                      <select [(ngModel)]="editConditionalField"
                        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                        <option value="">— Campo —</option>
                        @for (cf of conditionFieldsFor(item); track cf.id) {
                          <option [value]="cf.fieldName">{{ cf.fieldLabel }}</option>
                        }
                      </select>
                      <select [(ngModel)]="editConditionalOperator"
                        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                        @for (op of conditionalOperators; track op.value) {
                          <option [ngValue]="op.value">{{ op.label }}</option>
                        }
                      </select>
                      <input type="text" [(ngModel)]="editConditionalValue" placeholder="Valor"
                        class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                    </div>
                  }
                }
                <div class="flex items-center gap-2">
                  <button type="button" (click)="saveConditional(item)" [disabled]="saving"
                    class="text-xs px-2.5 py-1 rounded font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50">
                    Guardar condición
                  </button>
                  <button type="button" (click)="cancelEditConditional()"
                    class="text-xs px-2.5 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
                    Cancelar
                  </button>
                </div>
              </div>
            }
          </div>
          <div class="flex items-center gap-2 flex-shrink-0">
            @if (editingConditionalId !== item.id) {
              <button type="button" (click)="startEditConditional(item)"
                class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
                Condición
              </button>
            }
            <button type="button" (click)="toggle(item)"
              class="text-xs px-2 py-1 rounded border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-300">
              {{ item.isActive ? 'Desactivar' : 'Activar' }}
            </button>
            @if (!item.isSystem) {
              <button type="button" (click)="remove(item)"
                class="text-xs px-2 py-1 rounded border border-error-300 text-error-600 hover:bg-error-50">
                Eliminar
              </button>
            }
          </div>
        </li>
      }
    </ul>
  }
</div>
